import { makeAutoObservable, runInAction } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

const defaultMode = 'light';

class AppearanceStore {
  mode = defaultMode;

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);

    makePersistable(this, {
      name: 'AppearanceStore',
      properties: ['mode'],
    });
  }

  set(value = defaultMode) {
    runInAction(() => {
      if (value === 'light' || value === 'dark') {
        this.mode = value;
      }
    });
  }

  get() {
    return this.mode || defaultMode;
  }

  toggle() {
    this.set(this.get() === 'dark' ? 'light' : 'dark');
  }

  async clearStore() {
    await clearPersistedStore(this);
    // clearing persistence alone leaves the observable on its old value, so the
    // UI keeps the signed-out user's mode until a full reload
    this.set(defaultMode);
  }
}

export default AppearanceStore;
